import React from "react";
import { faSignal } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const getOnlineIcon = (value) => (
    <FontAwesomeIcon
        icon={faSignal}
        className={value && value.online ? "text-success" : "text-danger"}
    />
);

export default getOnlineIcon;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/helpers/get-online-icon.js